<template>
  <div class="customerCase wow animate__animated animate__fadeIn">
    <Loading :visible="loading"></Loading>

    <!-- 基础介绍区域 -->
    <div class="basicIntro wow animate__animated animate__fadeIn">
      <div class="mainBox introText">
        <div>卓越客户 · 共同成长</div>
        <div>携手耀客物联，高效管理实验室</div>
        <div class="btn maria">
          <span class="b-text" @click="navTo('/consult')">方案咨询</span>
        </div>
      </div>
    </div>

    <!-- 标签页区域 - 移至basicIntro下方 -->
    <div class="labTypes" :class="{ 'is-fixed': isTabFixed, 'is-absolute': isTabAbsolute }">
      <el-tabs v-model="currentKey" class="mainBox" @tab-click="handleChangeTab">
        <el-tab-pane :label="item.title" :name="item.key" v-for="item in CONSTOMER_TAB" :key="item.key"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 内容区域 -->
    <div class="content-wrapper" ref="contentWrapper">
      <div class="top" :style="{ marginTop: isTabFixed ? '9rem' : '2rem' }">
        <div class="friends">
          <div class="friendItem" v-for="(item, index) in list" :key="index"
            @click="navTo('/customerCaseDetail', { id: item.id })">
            <el-card shadow="hover" class="maria">
              <template #default>
                <div class="f-img">
                  <OssImg class="caseImg" :src="item.caseOssUrl" style="width: 100%" />
                </div>
                <div class="f-title">{{ item.caseTitle }}</div>
                <div class="f-desc ellipsis-multiline" style="-webkit-line-clamp: 2">
                  {{ item.caseRemark }}
                </div>
              </template>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watchEffect } from "vue";
import { useRouter } from "vue-router";
import CaseApi from "@/api/caseApi";
import { navTo } from "@/utils/util";
import { WOW } from "wowjs";
import OssImg from "@/components/ossImg.vue";

const caseApi = new CaseApi();
const loading = ref(true);
const router = useRouter();

// 标签数据
const CONSTOMER_TAB = ref([
  {
    title: "高等院校",
    key: "CollegesAndUniversities",
  },
  {
    title: "企事业单位科研院所",
    key: "ResearchInstitutes",
  },
  {
    title: "医院/疾控",
    key: "HospitalEnterprises",
  },
]);

// 状态管理
let currentKey = ref("CollegesAndUniversities");
const list = ref([]);
const contentWrapper = ref(null);
const basicIntroRef = ref(null);
const labTypesRef = ref(null);
const isTabFixed = ref(false);
const isTabAbsolute = ref(false);
const basicIntroHeight = ref(0);

// 获取案例列表
const getList = async () => {
  try {
    let res = await caseApi.getCaseList({
      caseType: currentKey.value,
    });
    list.value = res || [];
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};

// 处理标签切换
const handleChangeTab = (e) => {
  currentKey.value = e.props.name;
  getList();
};

// 初始化
onMounted(() => {
  // 初始化wow动画
  const wow = new WOW();
  wow.init();

  // 获取数据
  getList();

  // 计算基础介绍区域高度
  setTimeout(() => {
    const basicIntroEl = document.querySelector('.basicIntro');
    if (basicIntroEl) {
      basicIntroHeight.value = basicIntroEl.offsetHeight;
    }

    // 监听滚动事件
    window.addEventListener('scroll', handleScroll);
  }, 0);

  // 组件卸载时移除事件监听
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
});

// 处理滚动事件
const handleScroll = () => {
  if (!contentWrapper.value) return;

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  // 当滚动到顶部附近时固定标签
  if (scrollTop >= basicIntroHeight.value) {
    isTabFixed.value = true;
  } else {
    isTabFixed.value = false;
  }
};
</script>

<style lang="scss" scoped>
.basicIntro {
  width: 100vw;
  height: 22.375rem;
  padding: 1rem 0 2rem 0;
  background: #deedff url("@/assets/images/bg/customBg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .introText {
    width: 100%;

    >div:first-child {
      font-weight: bold;
      font-size: 2.5rem;
      color: #212121;
      margin-bottom: 1.5rem;
    }

    >div:nth-child(2) {
      font-weight: 500;
      font-size: 1.25rem;
      color: #888888;
      line-height: 2rem;
    }
  }

  .btn {
    margin-top: 1.5rem;
    display: inline-block;
    width: 97px;
    height: 37px;
    border-radius: 8px;
    background: #32A89E;
    color: #ffffff;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.customerCase {
  $titleSize: 60px;
  font-family: "PingFang SC";

  // 内容容器添加顶部间距，避免被固定的tab遮挡
  .content-wrapper {
    // padding-top: 6.25rem;
  }

  .labTypes {
    width: 100%;
    background: #f7f8fa;
    z-index: 99;
    transition: all 0.3s ease;

    // 固定定位样式
    &.is-fixed {
      position: fixed;
      top: 5rem;
    }

    // 绝对定位样式（当滚动到交界处时）
    &.is-absolute {
      position: absolute;
    }
  }

  .top {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 2rem;

    .title {
      margin: 56px 0px 42px 0px;
      color: rgba(33, 33, 33, 1);
      font-weight: 500;
      font-size: $titleSize;
      text-align: center;
    }

    .tabs {
      display: flex;
      justify-content: center;
      gap: 24px;

      .tab {
        width: 161px;
        height: 48px;
        line-height: 45px;
        border-radius: 8px;
        background: #fff;
        text-align: center;
        color: #424242;
        font-weight: 500;
        cursor: pointer;
        font-size: 16px;
      }

      .tab-active {
        background: #32a89e;
        color: #ffffff;
      }
    }

    .friends {
      min-height: 400px;
      margin-top: 32px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 1rem;

      .friendItem {
        height: 330px;
        margin-bottom: 32px;
        cursor: pointer;

        .f-img {
          width: 100%;
          height: 220px;

          .caseImg {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .f-title {
          color: #424242;
          font-size: 16px;
          font-weight: 500;
          margin: 13px 0px;
          padding: 0px 16px;
        }

        .f-desc {
          color: #888888;
          font-weight: 500;
          font-size: 14px;
          padding: 0px 16px;
        }

        .el-card {
          border-radius: 16px;
          height: 330px;

          :deep(.el-card__body) {
            padding: 0px;
          }
        }
      }
    }
  }

  footer {
    width: 100%;
    height: 259px;
    background-image: url("@/assets/images/bg/banner.png");
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: 5rem;
  }

  .bannerText {
    padding-top: 32px;
    color: #ffffff;
    text-align: center;
    font-weight: 600;
    font-size: 40px;
    width: 100%;

    .btn {
      margin: 0 auto;
      display: inline-block;
      width: 121px;
      height: 40px;
      border-radius: 8px;
      background: #32a89e;
      color: #ffffff;
      font-weight: 500;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .b-text {
        margin-right: 10px;
        transform: translateY(-2px);
      }
    }
  }
}

:deep(.el-tabs__nav-wrap:after) {
  background: none;
}

:deep(.el-tabs) {
  width: 100%;
  display: flex;
  align-items: center;
}

:deep(.el-tabs__item) {
  width: 33.3%;
  font-weight: bold;
  font-size: 1rem;
  color: #212121;

  &:hover {
    color: var(--primary-color);
  }
}

:deep(.el-tabs__item.is-active) {
  color: var(--primary-color);
}

:deep(.el-tabs__active-bar) {
  background: var(--primary-color);
  height: 1px;
  width: 13.25rem;
}

::v-deep .el-tabs__header {
  width: 100%;
}

::v-deep .el-tabs__nav {
  width: 100%;
  height: 6.25rem !important;
  border: none !important;
}

::v-deep .el-tabs__item {
  height: 6.75rem !important;
  border: none !important;
}
</style>